import * as React from 'react';

import CategoryCard from '@lendi-jam/category-card';
import { replaceElement } from '@lendi-jam/generic-rich-text';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import parse from 'html-react-parser';

import { CategoryCardContent } from '#contentTypes/CategoryCard';

interface PrismicCategoryCardProps {
  component: CategoryCardContent;
}

const PrismicCategoryCard: React.FC<PrismicCategoryCardProps> = ({ component }) => {
  const CategoryCardPrimary = component.primary;

  const CategoryCardItems = component.items.map((item) => ({
    title: item.card_title.text || '',
    subtitle: item.card_description.text || '',
    primaryButton: {
      url: embedMarketingTrackingIntoURL(item.primary_button_link.url) || '',
      text: item.primary_button_text.text || '',
    },
    secondaryButton: {
      url: embedMarketingTrackingIntoURL(item.secondary_button_link.url) || '',
      text: item.secondary_button_text.text || '',
    },
  }));

  return (
    <CategoryCard
      title={CategoryCardPrimary.card_collection_title?.text}
      subtitle={parse(CategoryCardPrimary.card_collection_subtitle.html, {
        replace: (domNode) => replaceElement(domNode, 'shade.0'),
      })}
      variant={CategoryCardPrimary.card_collection_variant}
      items={CategoryCardItems}
    />
  );
};

export default PrismicCategoryCard;
